<template>
    <div class="form-group">
        <label>{{ name }}</label>
        <input type="text" :name="'filter_'+id" :title="name" v-model="value_inner" class="form-control">
    </div>
</template>

<script>
    export default {
        props: ['id', 'name', 'value'],
        data: function() {
            return {
                value_inner: this.value
            }
        },
        watch: {
            value_inner: function(val,oldVal) {
                EaseEventBus.fire('resetExistingFilters');
                this.$emit('input',val);
            }
        }
    }
</script>
